export default __webpack_public_path__ + "static/pnc550-hytalk-529e2b5c9c48f91ff9dff170edbf68a1.png";